import { render, staticRenderFns } from "./TestProvocativiEditComponent.vue?vue&type=template&id=fe6fdb76"
import script from "./TestProvocativiEditComponent.vue?vue&type=script&lang=js"
export * from "./TestProvocativiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports